import { SLOTS } from './slots.js'

// User icons — moderation queue for member profile icons. Image-heavy, so it gets a
// grid view. Primary links to the user's social tab; review actions (approve / clear
// icon) live in the page's actions snippet; the Reports cell opens the per-report
// reason/details/reporter/reviewer rows (same renderer as the Reports queue).

export default {
  key: 'user_icon',
  label: 'User Icon',
  icon: 'user_icons',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'icon_image.image_url', renderer: 'avatar', labelField: 'name', link: 'url' },
    { slot: SLOTS.METADATA, field: 'user_reports_received', label: 'Reports', renderer: 'report_summary' },
    { slot: SLOTS.TEMPORAL, field: 'created_at', label: 'Created', renderer: 'date' }
  ],
  empty: { icon: 'user_icons', message: 'No users with profile icons found.' },
  defaultView: 'table',
  grid: { show: [SLOTS.PRIMARY, SLOTS.METADATA], columns: 4 },
  compact: { show: [SLOTS.PRIMARY, SLOTS.METADATA] }
}
